import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.25 6.5c0-.465.383-.875.875-.875A.9.9 0 0 1 19 6.5v4.375a2.626 2.626 0 0 1-2.625 2.625H7.98l1.997 2.023a.843.843 0 0 1 0 1.23.843.843 0 0 1-1.23 0l-3.5-3.5a.843.843 0 0 1 0-1.23l3.5-3.5a.843.843 0 0 1 1.23 0 .843.843 0 0 1 0 1.23L7.98 11.75h8.395a.88.88 0 0 0 .875-.875z"
    }, null, -1)
  ]))]))
}
export default { render: render }